// API Configuration
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

// Helper function to build API URLs
export function buildApiUrl(path: string): string {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
}

// Common API endpoints
export const API_ENDPOINTS = {
  // Auth
  GOOGLE_AUTH: buildApiUrl('auth/google'),
  AUTH_LOGOUT: buildApiUrl('auth/logout'),

  // User
  USER_ME: buildApiUrl('user/me'),
  USER_UPDATE: buildApiUrl('user/update'),
  USER_LICENSE: buildApiUrl('user/license'),

  // Subscriptions
  SUBSCRIPTION_ME: buildApiUrl('subscriptions/me'),
  SUBSCRIPTION_UPGRADE: buildApiUrl('subscriptions/upgrade'),
  SUBSCRIPTION_DOWNGRADE: buildApiUrl('subscriptions/downgrade'),
  SUBSCRIPTION_CANCEL: buildApiUrl('subscriptions/cancel'),

  // Stats
  STATS: buildApiUrl('stats'),
  STATS_PROGRESS: buildApiUrl('stats/progress'),
  STATS_INTERACTIONS: buildApiUrl('stats/interactions'),

  // Words
  WORDS: buildApiUrl('user/words'),

  // Leads
  LEADS: buildApiUrl('leads'),

  // Revision
  LEARN_HISTORY: buildApiUrl('learn/history'),
  LEARN_COLLECTION: buildApiUrl('learn/collection'),

  // Audio
  AUDIO_STREAM: buildApiUrl('learn/audio/stream'),
} as const;
